import { Form, Formik } from "formik";
import CardContent from '@mui/material/CardContent';
import Image0 from '../../../../components/images/Image0';
import OutlinedTextField from '../../../../components/formFields/OutlinedTextField';
import loginInitialValues from "./LoginInitialValues";
import loginValidationSchema from "./LoginValidationSchema";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ErrorToast from "../toasts/ErrorToast";
import { authenticate } from "../../../../api/accountApi";
import { setSessionStorage ,setSessionStorage2} from "../../../../utils/StorageUtil";
import { useState } from "react";
import { checkSOData, TOKEN_SO_KEY ,GATEWAY_TOKEN} from "../../../../utils/accountUtils";
import LoginLink from "../buttons/LoginLink";
import Button from '@mui/material/Button';
import { Trans } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import packageJson from '../../../../../package.json';


export default function() {
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false)

  const handleSubmit = (values: any, actions: any) => {
    setShowToast(false)
    authenticate({
      username: values.username,
      password: values.password,
      rememberMe: false
    }).then(async (response) => {
      if (!!response) {
        setSessionStorage(TOKEN_SO_KEY, response.data.id_token)
        setSessionStorage2(GATEWAY_TOKEN,'"'+response.data.id_token+'"')
        await checkSOData()
        navigate(`/web/`, { replace: true })
      }
    }).catch(() => {
      setShowToast(true)
    }).finally(() => {
      actions.resetForm()
    })
  }

  const handleSearchVehicle = () => {
    navigate(`/web/search-vehicles`, { replace: true })
  }

  return (
    <Formik
      initialValues={loginInitialValues}
      onSubmit={handleSubmit}
      validationSchema={loginValidationSchema}
      isInitialValid={false}
    >
      {({ isSubmitting, isValid }) => (
        <Form id="login">
          <CardContent sx={{ padding: {xs: '16px 5%', sm: '16px 5%', md: '16px 5%', lg: '16px 12%'}}}>
          <Box sx={{ margin: '15px 0 40px', textAlign: 'right', color: '#707070', fontSize: '12px' }}>
              Versión {packageJson.version}
            </Box>
            <Box sx={{ margin: '15px 0 40px', textAlign: 'center' }}>
              <Image0></Image0>
            </Box>
            <OutlinedTextField
                  label={`screens.login.sections.formFields.username`}
                  name="username"
                  autoComplete="username"
                  fullWidth={true}
                  i18n
                />
            <OutlinedTextField
                  className="field-password"
                  label={`screens.login.sections.formFields.password`}
                  name="password"
                  autoComplete="current-password"
                  password
                  fullWidth={true}
                  i18n
                />
            <Box className="login-links-section">
              <LoginLink i18nKey={`screens.login.sections.main.recoverPasswordLink`} navigatePath="/web/recover-password"></LoginLink>
              <LoginLink i18nKey={`screens.login.sections.main.registerLink`} navigatePath="/web/register"></LoginLink>
              {showToast && <ErrorToast></ErrorToast>}
            </Box>
            <Box textAlign="center" mt={4}>
              <Button disabled={!isValid || isSubmitting} className="primary login" size="small" type="submit">
                <Trans i18nKey={`screens.login.sections.main.submitButton`}></Trans>
              </Button>
            </Box>
            <Box textAlign="center">
              <Button startIcon={<SearchIcon />} onClick={handleSearchVehicle} className="login-search-vehicle-button" size="small">
                <Trans i18nKey={`screens.login.sections.main.searchVehiclesButton`}></Trans>
              </Button>
            </Box>
          </CardContent>
        </Form>
      )}
    </Formik>
  );
}